/* Fitness Sports events + results loader.
   Data: assets/fs-results.json (full archive, generated by wp/build_results.py) merged with a live overlay of the
   250 most recently updated fs_event metaobjects from the Storefront API when a public token is configured.
   Shared by sections/fs-events.liquid (upcoming + recent results) and sections/fs-results.liquid (finder). */
(function () {
  if (window.FSEvents) return;
  var cache = {}, pending = {};

  function parseJSON(s, d) { try { return JSON.parse(s); } catch (e) { return d; } }
  function norm(s) { return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function esc(s) { return (s || '').toString().replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function safeUrl(u) { u = (u || '').trim(); return /^(https?:\/\/|\/|mailto:)/i.test(u) ? u : ''; }

  /* Normalised event record */
  function rec(o) {
    o.title = o.title || o.handle; o.date = o.date || ''; o.distances = o.distances || []; o.years = (o.years || []).map(String);
    o.results = (o.results || []).map(function (x) { return [String(x[0]), safeUrl(x[1])]; }).filter(function (x) { return x[1]; });
    if (!o.years.length) o.years = o.results.map(function (x) { return x[0]; });
    o.results.sort(function (a, b) { return b[0].localeCompare(a[0]); });
    var seen = {};
    o.results.forEach(function (x) { seen[x[0]] = (seen[x[0]] || 0) + 1; x[2] = seen[x[0]] > 1 ? x[0] + ' (' + seen[x[0]] + ')' : x[0]; });
    o.years = o.years.filter(function (y, i, a) { return a.indexOf(y) === i; }).sort().reverse();
    o.k = norm([o.title, o.city, o.state, o.distances.join(' '), o.type, o.years.join(' ')].join(' '));
    return o;
  }

  /* Storefront API overlay: most recently updated first, one page of 250 */
  function fetchLive(domain, token, version) {
    var q = 'query { metaobjects(type: "fs_event", first: 250, sortKey: "updated_at", reverse: true) { nodes { handle updatedAt ' +
      'title: field(key: "title") { value } event_date: field(key: "event_date") { value } start_time: field(key: "start_time") { value } ' +
      'city: field(key: "city") { value } state: field(key: "state") { value } venue: field(key: "venue") { value } distances: field(key: "distances") { value } ' +
      'event_type: field(key: "event_type") { value } organizer: field(key: "organizer") { value } cost: field(key: "cost") { value } ' +
      'registration_url: field(key: "registration_url") { value } results_url: field(key: "results_url") { value } website_url: field(key: "website_url") { value } ' +
      'years: field(key: "years") { value } results_by_year: field(key: "results_by_year") { value } description: field(key: "description") { value } } } }';
    return fetch('https://' + domain + '/api/' + (version || '2025-07') + '/graphql.json', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token }, body: JSON.stringify({ query: q })
    }).then(function (r) { return r.json(); }).then(function (j) {
      var nodes = (j.data && j.data.metaobjects && j.data.metaobjects.nodes) || [];
      return nodes.map(function (n) {
        var v = function (k) { return n[k] && n[k].value ? n[k].value : ''; };
        var links = parseJSON(v('results_by_year'), []) || [];
        var results = links.map(function (l) { return [l.text, l.url]; });
        if (!results.length && v('results_url')) results = [[(v('event_date') || '').slice(0, 4), v('results_url')]];
        return rec({ handle: n.handle, title: v('title'), date: v('event_date'), time: v('start_time'), city: v('city'), state: (v('state') || '').trim(), venue: v('venue'),
          distances: parseJSON(v('distances'), []) || [], type: v('event_type'), organizer: v('organizer'), cost: v('cost'), reg: safeUrl(v('registration_url')),
          web: safeUrl(v('website_url')), results: results, years: parseJSON(v('years'), []) || [], desc: v('description'), live: true });
      });
    });
  }

  function load(opts) {
    var src = opts.src;
    if (cache[src]) return Promise.resolve(cache[src]);
    if (pending[src]) return pending[src];
    var key = 'fs-events-v2:' + src.split('?')[0].slice(-40);
    var cached = null;
    try { cached = parseJSON(sessionStorage.getItem(key), null); if (cached && Date.now() - cached.t > 10 * 60 * 1000) cached = null; } catch (e) {}
    if (cached) { cache[src] = cached.data; return Promise.resolve(cache[src]); }
    var base = fetch(src, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (j) {
      var prefix = j.prefix || '';
      return (j.races || j.events || []).map(function (r) {
        r.r = (r.r || []).map(function (x) { return [x[0], (x[1] && x[1].charAt(0) === '~') ? prefix + x[1].slice(1) : x[1]]; });
        return rec({ handle: r.h, title: r.t, date: r.dt || '', time: r.tm, city: r.c, state: r.st, venue: r.v, distances: r.d || [], type: r.ty, organizer: r.o, cost: r.co,
          reg: safeUrl(r.reg), web: safeUrl(r.web), results: r.r || [], years: r.y || [], desc: r.ds || '' });
      });
    });
    var live = (opts.token && opts.domain) ? fetchLive(opts.domain, opts.token, opts.version).catch(function () { return []; }) : Promise.resolve([]);
    pending[src] = Promise.all([base, live]).then(function (res) {
      var byHandle = {};
      res[0].forEach(function (e) { byHandle[e.handle] = e; });
      res[1].forEach(function (e) { byHandle[e.handle] = e; });
      var all = Object.keys(byHandle).map(function (h) { return byHandle[h]; });
      cache[src] = { events: all, live: res[1].length > 0 };
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), data: cache[src] })); } catch (e) {}
      return cache[src];
    });
    return pending[src];
  }

  /* ---------- Upcoming + recent results (fs-events section) ---------- */
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function d(iso) { var p = iso.split('-'); return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2])); }
  function card(e, past) {
    var dt = d(e.date), meta = ['<span class="visually-hidden">' + DAYS[dt.getUTCDay()] + ' ' + MONTHS[dt.getUTCMonth()] + ' ' + dt.getUTCDate() + ', ' + dt.getUTCFullYear() + '.</span>'];
    if (e.time) meta.push('<span>' + esc(e.time) + '</span>');
    if (e.city || e.state) meta.push('<span>' + esc([e.city, e.state].filter(Boolean).join(', ')) + '</span>');
    if (e.venue) meta.push('<span>' + esc(e.venue) + '</span>');
    var tags = e.distances.slice(0, 5).map(function (x) { return '<span class="fs-ev__tag">' + esc(x) + '</span>'; });
    if (e.type) tags.push('<span class="fs-ev__tag fs-ev__tag--type">' + esc(e.type) + '</span>');
    if (e.cost) tags.push('<span class="fs-ev__tag fs-ev__tag--muted">' + esc(e.cost) + '</span>');
    var acts = [];
    if (!past && e.reg) acts.push('<a class="fs-ev__btn" href="' + esc(e.reg) + '" target="_blank" rel="noopener">Register</a>');
    if (e.results.length) {
      acts.push('<span class="fs-ev__results"><span class="fs-ev__results-label">Results</span>' + e.results.map(function (x) {
        return '<a class="fs-ev__yl" href="' + esc(x[1]) + '" target="_blank" rel="noopener">' + esc(x[2] || x[0]) + '</a>';
      }).join('') + '</span>');
    }
    if (e.web) acts.push('<a class="fs-ev__link" href="' + esc(e.web) + '" target="_blank" rel="noopener">Race website</a>');
    return '<article class="fs-ev__card' + (past ? ' fs-ev__card--past' : '') + '">' +
      '<div class="fs-ev__date" aria-hidden="true"><span class="fs-ev__dnum">' + dt.getUTCDate() + '</span><span class="fs-ev__dmon">' + MONTHS[dt.getUTCMonth()].slice(0, 3) + '</span></div>' +
      '<div class="fs-ev__body"><h4 class="fs-ev__title">' + esc(e.title) + '</h4><p class="fs-ev__meta">' + meta.join('') + '</p>' +
      (tags.length ? '<p class="fs-ev__tags">' + tags.join('') + '</p>' : '') +
      (e.organizer ? '<p class="fs-ev__org">Organized by ' + esc(e.organizer) + '</p>' : '') +
      '<div class="fs-ev__actions">' + acts.join('') + '</div></div></article>';
  }
  function groups(list, past) {
    var out = '', cur = '';
    list.forEach(function (e) {
      var mk = e.date.slice(0, 7);
      if (mk !== cur) { if (cur) out += '</div></section>'; var dt = d(e.date); out += '<section class="fs-ev__month"><h3 class="fs-ev__month-title">' + MONTHS[dt.getUTCMonth()] + ' ' + dt.getUTCFullYear() + '</h3><div class="fs-ev__list">'; cur = mk; }
      out += card(e, past);
    });
    if (cur) out += '</div></section>';
    return out;
  }
  function renderEvents(root, data) {
    var today = new Date(); var t = today.toISOString().slice(0, 10);
    var ly = new Date(Date.UTC(today.getUTCFullYear() - 1, today.getUTCMonth(), today.getUTCDate())).toISOString().slice(0, 10);
    var max = parseInt(root.dataset.maxItems, 10) || 30;
    var up = data.events.filter(function (e) { return e.date && e.date >= t; }).sort(function (a, b) { return a.date.localeCompare(b.date) || a.title.localeCompare(b.title); });
    var past = data.events.filter(function (e) { return e.date && e.date < t && e.date >= ly; }).sort(function (a, b) { return b.date.localeCompare(a.date) || a.title.localeCompare(b.title); });
    var html = up.length ? groups(up.slice(0, max), false) : '<p class="fs-ev__empty">' + esc(root.dataset.emptyText || 'No upcoming events listed yet. Check back soon.') + '</p>';
    if (root.dataset.showPast === 'true') {
      html += '<h3 class="fs-ev__past-title">' + esc(root.dataset.pastHeading || 'Recent results') + '</h3>';
      html += past.length ? groups(past.slice(0, max), true) : '<p class="fs-ev__empty">No results from the past 12 months yet.</p>';
    }
    var target = root.querySelector('[data-fs-events-body]');
    if (target) { target.innerHTML = '<!-- fs-events: rendered from ' + (data.live ? 'live metaobjects + archive' : 'archive json') + ' (' + up.length + ' upcoming, ' + past.length + ' past) -->' + html; }
  }

  window.FSEvents = { load: load, norm: norm, esc: esc, renderEvents: renderEvents };

  document.querySelectorAll('[data-fs-events]').forEach(function (root) {
    if (root.dataset.src) {
      load({ src: root.dataset.src, domain: root.dataset.domain, token: root.dataset.token, version: root.dataset.apiVersion }).then(function (data) { renderEvents(root, data); }).catch(function () {});
    }
  });
})();
